<div  class="flex items-center justify-between relative">
    <h1 mat-dialog-title> {{ documentTitle }} </h1>
    <app-filter-card UnlimitedHeight MaxWidthHundertPercent #orderDialogFilter [Settings]="ArlFilterSettings$ | async" [Values]="dataSource.arlFilterValues$ | async"  (ValuesChange)="dataSource.arlFilterValues$.next($event)"></app-filter-card>

    <button
        (click)="orderDialogFilter.Toggle(); $event.stopPropagation()"
        app-round-button
        matTooltip="Filter"
        class="mat-badge-more-overlay"
        [matBadge]="FilterAmount$ | async"
        [matBadgeHidden]="!(FilterAmount$ | async)"
        [matBadgeOverlap]="true"
    >
        <fa-icon icon="filter"></fa-icon>
    </button>
</div>

<mat-dialog-content class="relative">
    <div class="flex gap-2 flex-wrap">
        <mat-form-field class="grow">

            <fa-icon matSuffix icon="times" style="margin-left: 3px; cursor: pointer;" (click)="supplierForm.setValue(null);$event.stopPropagation();" *ngIf="!supplierForm.disabled"></fa-icon>
            <app-select-search-paged-options
                #pagedSelect
                [placeholder]="supplierLable"
                [formControl]="supplierForm"
                [Options]="filteredSupplierOptions$ | async"
                [isLoading]="this.customerSearch.loading$ | async"
                [CompareOptions]="customerCompareOptions"
                (searchChange)="customerserverSearch($event)"
                (opened)="customerserverSearch('')"
                (ngModelChange)="materialSelection.clear()"
            >

                <mat-paginator
                    option-list-footer
                    #paginatorCustomer
                    [pageSize]="50"
                    [length]="(this.customerSearch.customerPaging.pageCount$ | async) * 50"
                    [pageIndex]="this.customerSearch.customerPaging.pageIndex$ | async"
                    (page)="customerpageChange?.($event)"
                >
                </mat-paginator>
            </app-select-search-paged-options>
<!--            <app-select-search [disabled]="this.ls.IsLoading$ | async" [placeholder]="this.supplierLable "-->
<!--                               [formControl]="supplierForm" [Options]="supplierOptions$ | async"-->
<!--                               [CompareOptions]="compareById"-->
<!--                               (ngModelChange)="materialSelection.clear()"></app-select-search>-->
<!--            <button (click)="$event.stopPropagation(); supplierForm.setValue(null)" mat-icon-button matSuffix *ngIf="supplierForm.value">-->
<!--                <fa-icon icon="times"></fa-icon>-->
<!--            </button>-->
        </mat-form-field>

        <mat-form-field class="grow">
            <app-select-search [disabled]="this.ls.IsLoading$ | async" [placeholder]="commissionLabel$ | async" [formControl]="commissionForm" [Options]="commissionOptions$ | async" [CompareOptions]="compareById"></app-select-search>
            <button (click)="$event.stopPropagation(); commissionForm.setValue(null)" mat-icon-button matSuffix *ngIf="commissionForm.value">
                <fa-icon icon="times"></fa-icon>
            </button>
        </mat-form-field>
    </div>
    <div class="wrapper">
        <app-loading class="w-full loading" *ngIf="dataSource.isLoadingResults$ | async" [Transparent]="'shade'"></app-loading>
        <div class="scroll-container">

            <table mat-table class="full-width-table" matSort aria-label="Elements">
                <!--            <mat-text-column *ngFor="let columnName of displayedColumns" [matColumnDef]="columnName" [name]="columnName"></mat-text-column>-->

                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox
                            color="primary"
                            [disabled]="ls.IsLoading$ | async"
                            (change)="$event ? toggleAllRows() : null"
                            [checked]="materialSelection.hasValue() && (isAllSelected$ | async)"
                            [indeterminate]="materialSelection.hasValue() && !(isAllSelected$ | async)"
                        >
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox color="primary" [disabled]="ls.IsLoading$ | async" (click)="$event.stopPropagation()" (change)="$event ? materialSelection.toggle(row) : null" [checked]="materialSelection.isSelected(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>

<!--                <ng-container matColumnDef="costAmount">-->
<!--                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ HeaderMap.costAmount }}</th>-->
<!--                    <td mat-cell *matCellDef="let row">-->
<!--                        <div class="flex items-center">-->
<!--                            <span>{{ row.costAmount }}</span>-->
<!--                            <button mat-icon-button matTooltip="Preisgestaltung" (click)="onPriceInformationClick(row)">-->
<!--                                <fa-icon icon="info-circle"></fa-icon>-->
<!--                            </button>-->
<!--                        </div>-->
<!--                    </td>-->
<!--                </ng-container>-->

                <ng-container *ngFor="let columnName of displayedTextColumns" [matColumnDef]="columnName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ HeaderMap[columnName] }}</th>
                    <td mat-cell *matCellDef="let row">{{ row[columnName] }}</td>
                </ng-container>
                <ng-container matColumnDef="bookingText$">
                    <th mat-header-cell *matHeaderCellDef>Art-Nr.</th>
                    <td mat-cell *matCellDef="let row">{{ row.bookingText$ | async }}</td>
                </ng-container>
                <ng-container matColumnDef="supplierName$">
                    <th mat-header-cell *matHeaderCellDef>{{ supplierLabel$ | async }}</th>
                    <td mat-cell *matCellDef="let row">{{ row.supplierName$ | async }} </td>
                </ng-container>
                <ng-container matColumnDef="quantityForm">
                    <th mat-header-cell *matHeaderCellDef>{{ documentQuantityLable }}</th>
                    <td mat-cell *matCellDef="let row">
                        <mat-form-field appearance="outline" class="small-form mat-form-field-without-padding-bottom">
                            <input matInput type="number" [formControl]="row.quantityForm">
                        </mat-form-field>
                    </td>
                </ng-container>
                <ng-container matColumnDef="alreadyOrderedQuantityForCommissionNew$">
                    <th mat-header-cell *matHeaderCellDef>für {{ commissionLabel$ | async }} {{ documentLabel }} ({{liLabelNew}}) <app-hint-icon hint="Alle {{documentPluralLabel}} mit dem Status {{liLabelNew}} vom ausgewählten {{commissionLabel$ | async}}"></app-hint-icon></th>
                    <td mat-cell *matCellDef="let row">{{ row.alreadyOrderedQuantityForCommissionNew$ | async }}</td>
                </ng-container>
                <ng-container matColumnDef="alreadyOrderedQuantityForCommissionShipped$">
                    <th mat-header-cell *matHeaderCellDef>für {{ commissionLabel$ | async }} {{ documentLabel }} ({{liLabelShipped}}) <app-hint-icon hint="Alle {{documentPluralLabel}} mit dem Status {{liLabelShipped}} vom ausgewählten {{commissionLabel$ | async}}"></app-hint-icon></th>
                    <td mat-cell *matCellDef="let row">{{ row.alreadyOrderedQuantityForCommissionShipped$ | async }}</td>
                </ng-container>
                <ng-container matColumnDef="alreadyOrderedQuantityForCommissionBooked$">
                    <th mat-header-cell *matHeaderCellDef>für {{ commissionLabel$ | async }} {{ documentLabel }} ({{liLabelBooked}}) <app-hint-icon hint="Alle {{documentPluralLabel}} mit dem Status {{liLabelBooked}} vom ausgewählten {{commissionLabel$ | async}}"></app-hint-icon></th>
                    <td mat-cell *matCellDef="let row">{{ row.alreadyOrderedQuantityForCommissionBooked$ | async }}</td>
                </ng-container>
                <ng-container matColumnDef="costAmountFromMaterialToSupplierOrMaterial$">
                    <th mat-header-cell *matHeaderCellDef>EK Preis (Stammdaten) <app-hint-icon hint="Dies ist der Preis vom ausgewählten {{suppliersLabel$ | async}}, falls vorhanden ansonsten aus den Stammdaten des Materials "></app-hint-icon></th>
                    <td mat-cell *matCellDef="let row">
                        <div class="flex items-center">
                            <span> {{ row.costAmountFromMaterialToSupplierOrMaterial$ | async }}</span>
                            <button *ngIf="row.materialId" mat-icon-button matTooltip="Preisgestaltung" (click)="onPriceInformationClick(row)">
                                <fa-icon icon="info-circle"></fa-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    [class.correct]="(row.orderedDiff$ | async) === 0"
                    [class.less]="(row.orderedDiff$ | async) < 0"
                    [class.much]="(row.orderedDiff$ | async) > 0"
                ></tr>
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" [attr.colspan]="displayedColumns.length">keine Materialien vorhanden</td>
                </tr>
            </table>
        </div>
    </div>
    <app-mat-paginator-wrapper>
    <mat-paginator #paginator [length]="dataSource?.filteredDataLength$ | async" [pageIndex]="0" [pageSize]="50" [pageSizeOptions]="[50, 100]" aria-label="Seite wählen"> </mat-paginator>
    </app-mat-paginator-wrapper>
</mat-dialog-content>
<mat-dialog-actions class="gap-2">
    <button app-button Color="cancel" Inverted mat-dialog-close="" [IsLoading]="ls.IsLoading$ | async">Abbrechen</button>
    <span class="grow"></span>
    <button app-button Color="green" [Disabled]="materialSelection.isEmpty()" (click)="onSubmitAndRouteClick()" [IsLoading]="ls.IsLoading$ | async">{{documentTitle}} & zum Dokument Wechseln</button>
    <button app-button Color="green" [Disabled]="materialSelection.isEmpty()" (click)="onSubmitClick()" [IsLoading]="ls.IsLoading$ | async">{{documentTitle}}</button>
</mat-dialog-actions>
